const endpoints = {
  calculateDishSalesForecastByDate: "CalculateDishSalesForecastByDateFunction",
  calculateSalesAggregate: "CalculateSalesAggregate",
  calculateSalesMix: "CalculateSalesMix",

  getSalesAggregate: "GetSalesAggregateFunction",
  getSalesRevenueForecastFunction: 'GetSalesRevenueForecastFunction',
  weatherTimeline: 'weathertimeline',

  saveSalesRevenueForecast: "SaveSalesRevenueForecastFunction",
  publicHolidayBase: "https://date.nager.at/api/v3/PublicHolidays/",

//Users
  getUserProfile: "GetUserProfileMenu"

};

export { endpoints };
